import NotFoundScreen from "components/NotFoundScreen"

export const Error404 = () => {
  return (
     <NotFoundScreen />
  )
}